import { createFileRoute } from '@tanstack/react-router'
import { PrivacySettingsFeature } from '@/features/organizations/settings/privacy'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/privacy'
)({
  component: PrivacySettingsFeature,
})
